import { BadgeVariant } from '@palmetto/palmetto-components';

import { AccountRequirementStatus } from 'types';

export const milestoneBadgeStatusMap: {
  [key in AccountRequirementStatus]: {
    label: string;
    variant: BadgeVariant;
  };
} = {
  [AccountRequirementStatus.completed]: {
    label: 'Approved',
    variant: 'success',
  },
  [AccountRequirementStatus.rejected]: {
    label: 'Rejected',
    variant: 'danger',
  },
  [AccountRequirementStatus.pending]: {
    label: 'Pending',
    variant: 'warning',
  },
  [AccountRequirementStatus.submitted]: {
    label: 'Submitted',
    variant: 'warning',
  },
  [AccountRequirementStatus.resubmitted]: {
    label: 'Resubmitted',
    variant: 'warning',
  },
  [AccountRequirementStatus.inProgress]: {
    label: 'Submitted',
    variant: 'warning',
  },
  [AccountRequirementStatus.error]: {
    label: 'Error',
    variant: 'warning',
  },
} as const;
